<template>
    <div class="chat_wrap">
        <pop-request-mtm :show="Mtm" @accept="joinmtm" @close="mtmpopClose" title="1:1 채팅 신청"/>
        <div v-if="viewList">
            <chatroom-list />
        </div>
        {{roomout}}
        <div class="chatBase">
            <chat-header :usercount="users.length" v-if="headerdisplay" @updatesetting="updatesetting"/>
            <base-dialog :show="ckConnect" @close="confirm"
            >다른곳에서 접속 하셨습니다.
            </base-dialog>
            <chat-body
            :messages="messages"
            :admin_messages="admin_messages"
            :isChat="isChat"
            :ownerId ="owner_userId"
            :chat_roomId="chat_roomId"
            :ckstate="setstate"            
            @sendmessage="sendMessage"
            @initstate="initstate"
            />
        </div>
    </div>
</template>

<script>
import ChatHeader from "@/components/chat/parts/ChatHeader";
import ChatBody from "@/components/chat/parts/ChatBody";
import ChatroomList from '@/components/chat/ChatroomListWidget';
import PopRequestMtm from "@/components/ui/PopRequestMtm";
import { socketio } from '@/components/mixins/socketio.js';
export default {
  name: 'ChatBase',
  props: ['chat_roomId', 'headerdisplay','viewList','roomout','owner_userId'],
  data() {
    return {
      username: "",
      // messages: [],
      // users: [],
      // admin_messages: [],
      // currentUser: "",
      // userIP: "",
      test: this.$store.state.serverDomain,
      otherConnect: false,
      //isChat:true, //다른데서 접속하면 차단 시키기 위해
      //Mtm:false,
      // mtmRoomId:'',
      // mtmUserId:'',     
    };
  },
  mixins:[socketio]
  ,
  components: {
    ChatHeader,
    ChatBody,
    ChatroomList,
    PopRequestMtm
  },
  // created(){
  //       this.$store.dispatch('tryLogin');
  // },
  mounted() {
    // this.username = '손님_'+this.makeid(5) ;
    // console.log(this.username);
    console.log("test", this.test);
    this.currentUser = this.$store.getters.currentUser;
    this.userIP = this.$store.getters.userIP;
    //테스트 메세지
    // this.socket.emit('createMessage',{
    //     from : "WDJ",
    //     text : "Whats going on!"
    // }, function(message){
    //     console.log('서버응답:', message)
    // })
  },
  //method 시작=========================================================================
  methods: {
    confirm() {
      this.otherConnect = false;
    },
    updatesetting(type){
      
      if(type === "initmessage"){
        //메세지 초기화       
        if(this.messages.length >0){
          this.messages =[]; 
          this.messages.push({from:'Admin', text:'화면 초기화', color:'red'});       
        }     
      }
    },
   

    //랜덤 id 생성
    // makeid(length) {
    //     var result = '';
    //     var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    //     var charactersLength = characters.length;
    //     for ( var i = 0; i < length; i++ ) {
    //         result += characters.charAt(Math.floor(Math.random() * charactersLength));
    //     }
    //     return result;
    // },
  },
  //method 끝=========================================================================
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.getters.currentUser;
    },
    ckConnect() {
      return this.otherConnect;
    },
    ckroomout(){
        //console.log('룸아웃이벤트',this.roomout);
        return this.roomout;
    },    
  },
  watch:{
      ckroomout(roomid)
      {
          //alert('확인'+roomid);
          if(roomid)
          {
            this.socket.disconnect();
          }
      }
     
      
  },
  // updated() {
  //   this.username = this.$store.getters.currentUser.id;
  //   console.log("유저네임", this.username);
  // },
};
</script>

<style lang="scss" scoped>
.chat_wrap{
    display:flex;
    height: 100%;
    .chatBase {
        flex:1 1 auto;
        display: flex;
        flex-direction: column;
        background: #fff;
    }
}

</style>
